import styled from "styled-components";

interface ColorsProps {
  backgroundSecondary?: string;
  brandTertiary?: string;
  backgroundTertiary?: string;
  brandPrimary?: string;
  textBody?: string;
  themeColor?: string;
  checked?: boolean;
}

interface InputProps {
  disabled?: boolean;
}

export const HiddenInput = styled.input<InputProps>`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const CheckboxWrapper = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  @media screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;

export const TextStyles = styled.span<InputProps>`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const CustomCheckboxStyles = styled.div<ColorsProps>`
  width: 24px;
  height: 24px;
  border: 1px solid ${({ textBody }) => textBody};
  background: ${({ backgroundSecondary }) => backgroundSecondary};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.1s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  @media screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;

export const CustomCheckboxStylesItem = styled.div<ColorsProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background: ${({ textBody }) => textBody};
  border-radius: 3px;
  opacity: ${({ checked }) => (checked ? "1" : "0")};
  transform: ${({ checked }) => (checked ? "scale(1)" : "scale(0.9)")};
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

  @media screen and (max-width: 768px) {
    width: 14px;
    height: 14px;
  }
`;
